import { createSelector } from 'reselect';

import { Wallpaper } from '../action/helper/image';
import { State } from '../types';

export const accountSelector = (state: State): State['account'] =>
  state.account;

export const selectAccountWallpapers = createSelector(
  accountSelector,
  (account: State['account']): Wallpaper[] => account.wallpapers
);

export const selectAccountHasActiveSubsciption = createSelector(
  accountSelector,
  (account) => account.active_subscription
);

export const selectAccountWallpaperLink = createSelector(
  accountSelector,
  (account) => account.wallpaper_link
);

export const selectAccountTitle = createSelector(
  accountSelector,
  (account) => account.title
);

export const selectAccountId = createSelector(
  accountSelector,
  (account) => account.id
);

export const selectOrderCountryCode = createSelector(
  accountSelector,
  (account) => account.subscription?.order?.country_code
);
